import { roleBadgeClass } from '@/shared/utils/roleUtils';
import { computed } from 'vue';
import { ProjectRole, SystemRole } from '@/core/types/models/RoleTypes';
import { useRoute } from 'vue-router';
import { findNavigationItemByPath } from '@/shared/config/navigation';
import { useProjectStore } from '../stores/project';


export function useHeader() {
  const route = useRoute();
  const projectStore = useProjectStore();

  const currentNavItem = computed(() => {
    // Prefer returnTo-based context when available (e.g., session page reached from commit history)
    const returnTo = route.query.returnTo;
    if (typeof returnTo === 'string' && returnTo) {
      const contextItem = findNavigationItemByPath(returnTo);
      if (contextItem) {
        return contextItem;
      }
    }
    return findNavigationItemByPath(route.path);
  });

  const currentNavIcon = computed(() => {
    return currentNavItem.value?.icon || '';
  });

  const currentNavLabel = computed(() => {
    return currentNavItem.value?.label || '';
  });

  const requiresProjectContext = computed(() => route.meta.requiresProject !== false);

  const currentProject = computed(() => {
    return projectStore.getProjectById(projectStore.selectedProjectId) ?? null;
  });

  function getRoleClass(role: string) {
    switch (role) {
      case SystemRole.Administrator:
        // Use shared utility for system role badge styling
        return roleBadgeClass(role);
      case ProjectRole.ProjectOwner:
        return 'bg-warning/10 text-warning text-xs px-2 py-1 rounded-full font-medium';
      case ProjectRole.ProjectContributor:
        return 'bg-primary/10 text-primary text-xs px-2 py-1 rounded-full font-medium';
      case ProjectRole.ProjectViewer:
        return 'bg-accent/10 text-accent text-xs px-2 py-1 rounded-full font-medium';
      default:
        return 'bg-error/10 text-error text-xs px-2 py-1 rounded-full font-medium';
    }
  }

  return {
    currentNavItem,
    currentNavIcon,
    currentNavLabel,
    requiresProjectContext,
    currentProject,
    // pascalToHuman is now globally available as $pascalToHuman
    getRoleClass
  };
}
